import { useUserBranchLocations } from '../../hooks/useUserBranchLocations';
import { useUserSelectedBranchLocation } from '../../hooks/useUserSelectedBranchLocation';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';

const BranchLocationSelector = () => {
  const { locations } = useUserBranchLocations();
  const { selectBranchLocation } = useUserSelectedBranchLocation();
  const navigate = useNavigate();

  const setBranchLocation = (location) => {
    // Set state of newly selected branch location on the app
    selectBranchLocation(location);
    // Navigate to dashboard
    navigate('/user/admin-dashboard');
  };

  return (
    <>
      <Header />
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-8 col-sm-12 col-md-8 col-xl-8">
              <div className="card top-departments">
                <div className="card-header">
                  <h4 className="card-title mb-0">Select Clinic Location</h4>
                </div>
                <div className="card-body">
                  {locations?.map((location) => (
                    <div key={location?.clinicLocationId}>
                      <div className="departments-list pb-4">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h4>{location?.title}</h4>
                            <p>{location?.address}</p>
                          </div>
                          <div>
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={() => setBranchLocation(location)}
                            >
                              Select
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BranchLocationSelector;
